(function () {
  // Shopify money values in Liquid/JSON are integers in the shop's smallest
  // currency unit (cents), e.g. 11800 = $118.00.
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initProductForm(form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var variantIdInput = form.querySelector('[data-product-variant-id]');
    var priceWrap = form.closest('.product__info')
      ? form.closest('.product__info').querySelector('[data-product-price]')
      : null;
    var currentPriceEl = priceWrap ? priceWrap.querySelector('[data-current-price]') : null;
    var comparePriceEl = priceWrap ? priceWrap.querySelector('[data-compare-price]') : null;
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = form.querySelector('[data-add-to-cart-text]');
    var errorEl = form.querySelector('[data-product-form-error]');
    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]'));

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('.is-selected');
        return selected ? selected.getAttribute('data-option-value') : null;
      });
    }

    function findVariant(options) {
      return variants.filter(function (variant) {
        return variant.options.every(function (opt, i) {
          return options[i] === null || opt === options[i];
        });
      })[0];
    }

    function updateUI() {
      var options = selectedOptions();
      var variant = findVariant(options);

      if (!variant) {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        if (errorEl) {
          errorEl.textContent = 'This combination is not available.';
          errorEl.hidden = false;
        }
        return;
      }

      if (errorEl) errorEl.hidden = true;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(variant.price);

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('disabled');
          if (addBtnText) addBtnText.textContent = 'Add to Cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          if (addBtnText) addBtnText.textContent = 'Sold Out';
        }
      }
    }

    optionGroups.forEach(function (group) {
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-selected')) return;
          buttons.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          updateUI();
        });
      });
    });

    // AJAX add-to-cart: posts to the real Shopify /cart/add.js endpoint so the
    // cart drawer can update without a full page reload. Falls back to a normal
    // form submit (native browser behavior) if fetch itself is unavailable.
    if (window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.hasAttribute('disabled')) return;

        var quantityInput = form.querySelector('input[name="quantity"]');
        var payload = {
          id: variantIdInput ? variantIdInput.value : null,
          quantity: quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1
        };

        if (errorEl) errorEl.hidden = true;
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addBtnText) addBtnText.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error(result.data && result.data.description ? result.data.description : 'Could not add this item to your cart.');
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { openDrawer: true } }));
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message || 'Something went wrong — please try again.';
              errorEl.hidden = false;
            }
          })
          .then(function () {
            updateUI();
          });
      });
    }

    updateUI();
  }

  document.querySelectorAll('[data-product-form]').forEach(initProductForm);
})();
